<div class="details">
    <div class="row">
        <div class="col-sm-10 col-sm-9 col-md-8 col-lg-7">
            <div class="msg-title">{{ addressPanelForm.get("subject").value }}</div>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-sm-1">
            <label class="control-label col-form-label">Type:</label>
        </div>
        <div class="col-sm-7">
            <div class="input-group">
                <kno2-form-autocomplete
                    class="w-100"
                    [control]="addressPanelForm.get('releaseType')"
                    optionLabel="name"
                    [options]="releaseTypeOptions()"
                    [isGroup]="true"
                    placeholder="Select a type" />
            </div>
        </div>
    </div>
    <div class="form-group row">
        <label class="col-sm-1 control-label col-form-label">From:</label>
        <kno2-form-select
            class="col-sm-7"
            placeholder="Select an address"
            [control]="addressPanelForm.get('fromAddress')"
            [options]="fromAddressOptions()"
            [isDefaultOptionEnabled]="false"
            [hasError]="addressPanelForm.get('fromAddress').invalid && addressPanelForm.get('fromAddress').touched"
            errorClass="is-invalid" />
        <kno2-info-popover
            class="col-sm-1 d-flex align-items-center ps-0"
            content="Select the address or fax number from which you would like to send this message on behalf of." />
    </div>
    <div class="form-group row">
        <div class="col-sm-1 d-flex align-items-center">
            <label class="control-label col-form-label mb-0">To:</label>
            <kno2-cached-addresses-button class="ms-1" />
        </div>
        <div class="col-sm-10">
            <div class="input-group flex-nowrap">
                <kno2-form-tags-select
                    class="flex-fill h-100"
                    [placeholder]="canSelectFax() ? 'Add an address or fax number' : 'Add an address'"
                    [control]="addressPanelForm.get('toAddresses')"
                    optionLabel="label"
                    [options]="toAddressOptions()"
                    [showEmptyMessage]="false"
                    [debounceTime]="300"
                    (searchChange)="onToAddressSearchChange($event)" />

                <span
                    class="input-group-text"
                    role="button"
                    (click)="findProvider()">
                    <i class="fa fa-search"></i>
                </span>
            </div>
        </div>
        <kno2-info-popover
            class="col-sm-1 d-flex align-items-center ps-0"
            content="Enter the Direct Address in the Address section.  You may also use a fax number.  If you do not know or cannot find the Direct Address using the search option, you can send using their fax number or contact them for their address information." />
    </div>
</div>
